import { FilterResponse, FilterValueResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { FrontendFilters, FrontendFilterType } from '../../types/filters.type';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class GetHouseholdReferenceFilter extends BaseAdapter<FilterResponse> implements AdapterInterface {
  rawResponse: FilterResponse;

  async adaptResponse(): Promise<FrontendFilters> {
    await this.fetchApiResponse('/api/household-reference-filter', HTTPMethod.Get);
    return this.displayResponse();
  }

  displayResponse(): FrontendFilters {
    return {
      id: this.rawResponse.filter_name,
      displayName: this.rawResponse.display_name,
      placeholder: this.rawResponse.placeholder,
      type: this.rawResponse.type as FrontendFilterType,
      hasAllOption: this.rawResponse.has_all_option,
      filterValues: this.rawResponse.filter_values.map((filterValue: FilterValueResponse) => ({
        id: filterValue.name,
        displayName: filterValue.display_name,
      })),
    };
  }
}
